import { attr, fk, Model } from 'redux-orm';
import {
  createAction,
  createAddConst,
  createDeleteConst,
  createRequestConst,
  createUpdateConst,
  dateAndTime,
} from '../util';
import Payer from './payer';

export const sortableFields = [
  {
    name: 'Updated At',
    value: 'updatedAt',
    query: ['orderByUpdatedAt', 'desc'],
  },
  {
    name: 'Created At',
    value: 'createdAt',
    query: ['orderByCreatedAt', 'desc'],
  },
];

export default class PayerNotes extends Model {
  static get modelName() {
    return 'PayerNotes';
  }

  static reducer({ type, data }, PayerNotes, { Payer }) {
    switch (type) {
      case LOAD.SUCCESS:
        if (Payer.idExists(data?.props ? data.props.payerId : 0)) {
          Payer.withId(data?.props.payerId).payerNotes?.delete();
        }
        if (data.response) {
          data.response.forEach((r) => {
            r.insertedAtDerived = dateAndTime(r.insertedAt);
            PayerNotes.upsert(r);
          });
        }
        break;

      case LOAD_ID.SUCCESS:
        if (data?.response && typeof data.response === 'object') {
          data.response.createdAtDerived = dateAndTime(data.response.createdAt);
          PayerNotes.upsert(data.response);
        }
        break;

      case CREATE.SUCCESS:
        if (data?.response && typeof data.response === 'object') {
          PayerNotes.create(data.response);
        }
        break;

      case UPDATE.SUCCESS:
        if (
          data?.response &&
          typeof data.response === 'object' &&
          data.response.id
        ) {
          PayerNotes.withId(data.response.id).update(data.response);
        }
        break;

      case REMOVE.SUCCESS:
        if (
          data?.response &&
          typeof data.response === 'object' &&
          data.response.id
        ) {
          PayerNotes.withId(data.response.id).delete();
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      createdAt: attr(),
      createdAtDerived: attr(), // derived
      fsp: attr(),
      fspId: attr(),
      href: attr(),
      id: attr(),
      insAdminUserId: attr(),
      insAdminUserLogin: attr(),
      insAdminUserName: attr(),
      insUserId: attr(),
      insUserName: attr(),
      note: attr(),
      noteType: attr(),
      payer: attr(),
      payerId: fk(Payer.modelName, 'payerNotes'),
      updUserId: attr(),
      updatedAt: attr(),
    };
  }
}

const name = PayerNotes.modelName;

export const CREATE = createAddConst(name);
export const LOAD = createRequestConst(name);
export const LOAD_ID = createRequestConst(`${name}_id`);
export const REMOVE = createDeleteConst(name);
export const UPDATE = createUpdateConst(name);

export const create = createAction(CREATE);
export const load = createAction(LOAD);
export const loadById = createAction(LOAD_ID);
export const remove = createAction(REMOVE);
export const update = createAction(UPDATE);
